import { render, staticRenderFns } from "./dialog2.vue?vue&type=template&id=dd49dcc2&"
import script from "./dialog2.vue?vue&type=script&lang=js&"
export * from "./dialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports